import { render, staticRenderFns } from "./AddBillingAccount.vue?vue&type=template&id=b245defa&scoped=true"
import script from "./AddBillingAccount.vue?vue&type=script&lang=js"
export * from "./AddBillingAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b245defa",
  null
  
)

export default component.exports